module.exports = __webpack_public_path__ + "img/warning-icon.6f7bfb5a.png";